import React from "react";
import { tourismSteps, tourismBenefits } from "../mock/extra";
import { Plane, Hotel, Stethoscope, Landmark, ArrowRight, CheckCircle2, Globe, ShieldCheck, HandCoins, MessageCircle } from "lucide-react";

const stepIcons = [
  <MessageCircle className="w-6 h-6" key="a" />,
  <Plane className="w-6 h-6" key="b" />,
  <Stethoscope className="w-6 h-6" key="c" />,
  <Landmark className="w-6 h-6" key="d" />,
];

const benefitIcons = [<HandCoins key="h" />, <ShieldCheck key="s" />, <Globe key="g" />, <Hotel key="o" />];

export default function DentalTourism() {
  return (
    <section id="tourism" className="relative py-24 md:py-32 bg-[#f6f7f4] overflow-hidden">
      <div className="absolute -top-32 -left-32 w-[520px] h-[520px] rounded-full bg-[#14a68e]/10 blur-3xl pointer-events-none" />
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-8">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7">
            <div className="section-eyebrow">Dental Tourism in Lucknow</div>
            <h2 className="mt-4 font-serif-display text-[42px] md:text-[64px] leading-[1.03] text-[#0e2b2b]">
              World‑class dental care<br />
              <span className="hero-italic">in the City of Nawabs</span>
            </h2>
            <p className="mt-6 text-[15px] md:text-[16px] text-[#0e2b2b]/75 max-w-[620px] leading-relaxed">
              Planning dental treatment during your visit to India? Dr. Khurana&rsquo;s Dental &amp; Aesthetic Clinic in Lucknow welcomes NRI and international patients seeking dental implants, smile makeovers and comprehensive dental care. Connect with our team before you travel to discuss your concerns, treatment options, estimated costs and the time you may need in Lucknow.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <a href="#contact" className="btn-primary">Plan Your Dental Visit <ArrowRight size={16} /></a>
              <a href="https://wa.me/918601563494" target="_blank" rel="noreferrer" className="btn-ghost">WhatsApp Us <MessageCircle size={16} /></a>
            </div>
          </div>
          <div className="lg:col-span-5 grid grid-cols-2 gap-4">
            {tourismBenefits.map((b, i) => (
              <div key={b.title} className="bg-white rounded-2xl p-5 border border-[#0e2b2b]/10 card-lift">
                <span className="w-10 h-10 rounded-xl bg-[#eaf6f2] text-[#14a68e] flex items-center justify-center">
                  {React.cloneElement(benefitIcons[i], { className: "w-5 h-5" })}
                </span>
                <div className="mt-3 font-serif-display text-[19px] text-[#0e2b2b] leading-tight">{b.title}</div>
                <p className="mt-2 text-[13px] text-[#0e2b2b]/65 leading-relaxed">{b.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Steps */}
        <div className="mt-20">
          <div className="text-center max-w-xl mx-auto">
            <div className="text-[11px] tracking-[0.22em] uppercase font-semibold text-[#14a68e]">The Journey</div>
            <h3 className="mt-3 font-serif-display text-[30px] md:text-[42px] leading-[1.1] text-[#0e2b2b]">Simple, guided from your first message</h3>
          </div>

          <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
            {tourismSteps.map((s, i) => (
              <div key={s.step} className="relative bg-white rounded-3xl p-6 border border-[#0e2b2b]/10 card-lift">
                <div className="flex items-center justify-between">
                  <span className="w-11 h-11 rounded-2xl bg-[#0e2b2b] text-white flex items-center justify-center">{stepIcons[i]}</span>
                  <span className="font-serif-display text-[34px] text-[#14a68e]/40 leading-none">{s.step}</span>
                </div>
                <h4 className="mt-5 font-serif-display text-[20px] text-[#0e2b2b] leading-tight">{s.title}</h4>
                <p className="mt-2 text-[13.5px] text-[#0e2b2b]/70 leading-relaxed">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom band */}
        <div className="mt-16 bg-[#0e2b2b] text-white rounded-[32px] p-8 md:p-10 grid md:grid-cols-3 gap-6 items-center">
          <div className="md:col-span-2">
            <div className="text-[11px] tracking-[0.22em] uppercase text-[#5eead4] font-semibold">For international &amp; NRI patients</div>
            <div className="mt-3 font-serif-display text-[26px] md:text-[34px] leading-tight">Travel with a plan. Return with a reason to smile.</div>
          </div>
          <div className="flex flex-col gap-3">
            {["Pre-visit WhatsApp consultation", "Personalised treatment planning", "Estimated timeline & costs", "Post-treatment follow-up"].map((x) => (
              <div key={x} className="flex items-center gap-3 text-[14px]"><CheckCircle2 className="w-4 h-4 text-[#5eead4]" /> {x}</div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
